import ReadOnlyField from "../../../../../Forms/ReadOnly/ReadOnlyField";

const ApprovedInfoSection = ({ form }) => {
  if (!form.approvedByName) return null;

  return (
    <div className="grid grid-cols-2 gap-4 mt-4">
      <ReadOnlyField label="Aprobado Por" value={form.approvedByName} />
      <ReadOnlyField
        label="Fecha Aprobación"
        value={`${form.approvedDate} ${form.approvedTime}`}
      />
    </div>
  );
};

export default ApprovedInfoSection;
